import {
  startReleaseNoticePolling,
  type StartReleaseNoticePollingOptions,
} from "./releaseNoticePollClient";

declare global {
  interface Window {
    __eweadnStartReleaseNoticePolling?: (
      options: StartReleaseNoticePollingOptions
    ) => () => void;
  }
}

window.__eweadnStartReleaseNoticePolling = startReleaseNoticePolling;

/** defer 脚本执行时 currentScript 可能为 null，回退用选择器读取 data-* */
const script =
  (document.currentScript as HTMLScriptElement | null) ??
  document.querySelector<HTMLScriptElement>(
    "script[src*='release-notice-poll-client'][data-mode]"
  );
const projectCode = script?.dataset?.projectCode?.trim() || "eweadn-qiankun";
const mode =
  script?.dataset?.mode === "maintenance" ||
  document.documentElement?.getAttribute("data-maintenance-page") === "1"
    ? "maintenance"
    : "app";
const homeUrl = script?.dataset?.homeUrl?.trim() || "/";

if (mode === "maintenance") {
  startReleaseNoticePolling({
    projectCode,
    mode: "maintenance",
    homeUrl,
  });
}
